import { TileContainer } from "@vds/tiles";
import { Icon } from "@vds/icons";
import { Body, Title } from "@vds/typography";
import * as React from "react";
import styled from "styled-components";
import { breakpoints, device } from "../../styles/breakpoints";

const TileWrapper = styled.div`
  width: 100%;
  flex: 1;
  min-height: 112px;
  
  @media (max-width: ${breakpoints.tablet}) {
    flex-basis: 100%;
  }

  @media ${device.tablet} {
    min-width: 280px;
  }

  @media ${device.desktop} {
    min-width: 300px;
  }
`;

const TileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 16px 16px 16px;

  @media ${device.tablet} {
    padding: 32px 16px 20px 24px;
  }

  @media ${device.desktop} {
    padding: 40px 16px 24px 34px;
  }
`;

const TileHeader = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;

  @media ${device.tablet} {
    flex-wrap: nowrap;
    align-items: center;
  }
`;

const TileIconWrapper = styled.div`
  flex-shrink: 0;
`;

const TileTitleWrapper = styled.div`
  margin-top: 3px;
  margin-right: 2px;

  h5 {
    font-size: 16px;
    line-height: 20px;
  }

  @media ${device.tablet} {
    margin-top: 0;

    h5 {
      font-size: 18px;
      line-height: 22px;
    }
  }

  @media ${device.desktop} {
    h5 {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;

const TileDescriptionWrapper = styled.div`
  margin-top: 7px;

  p {
    font-size: 14px;
    line-height: 18px;
  }

  @media ${device.tablet} {
    margin-top: 0;

    p {
      font-size: 16px;
      line-height: 20px;
    }
  }

  @media ${device.desktop} {
    p {
      font-size: 18px;
      line-height: 22px;
    }
  }
`;

const TileArrowContainer = styled.div`
  display: flex;
  background-color: black;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 40px;
  border-radius: 0px 8px 8px 0px;
  flex-shrink: 0;
`;

export function SettingsTile({
  icon,
  title,
  description,
  onClick,
  dataTestId,
}) {
  return (
    <TileWrapper>
      <TileContainer
        width="100%"
        height="100%"
        padding="0px"
        data-testid="support_settingsTileMain"
        onClick={onClick}
        surface="dark"
        style={{ display: "flex", border: "2px solid black" }}
        backgroundColor="white"
        showBorder={true}
        data-track={`${dataTestId}_container_CTA`}
      >
        <TileContentContainer data-testid={`${dataTestId}_inner_content`}>
          <TileHeader>
            <TileIconWrapper>
              <Icon
                name={icon}
                size="XLarge"
                color="#000000"
                style={{ verticalAlign: "middle" }}
              />
            </TileIconWrapper>
            <TileTitleWrapper>
              <Title size="small" color="#000000" bold={true}>
                {title}
              </Title>
            </TileTitleWrapper>
            <TileDescriptionWrapper>
              <Body bold={false} color="black" size="large">
                {description}
              </Body>
            </TileDescriptionWrapper>
          </TileHeader>
        </TileContentContainer>
        <TileArrowContainer>
          <Icon name="right-caret" size="large" color="#ffffff" />
        </TileArrowContainer>
      </TileContainer>
    </TileWrapper>
  );
}
